// This is just an example,
// so you can safely delete all default props below

export default {
    reset_password: 'Bytt passord',
    password: 'Passord',
    repeat_password: 'Gjenta passord',
    set_password: 'Lag et passord',
    succeeded: 'Passordet ditt er nå endret.',
    failed: 'Feilet',
    error_password: 'Passordet må være minst 8 tegn, og må inneholde store/små bokstaver, tall og symboler.',
    error_password_repeat: 'Repetert passord må være det samme som nytt passord.',
}
